export default __webpack_public_path__ + "static/media/bonus3.f474be39.mov";